/**
 * Teacher "Preview as Student" (opened from the CMS Teacher Dashboard).
 *
 * INFO_KEY (localStorage) marks this browser's website session as a preview, so the preview banner
 * shows; logging out clears it with the rest of localStorage.
 */
const INFO_KEY = "studentPreview";

export const savePreviewInfo = (info) => {
	try {
		localStorage.setItem(INFO_KEY, JSON.stringify(info || {}));
	} catch (e) {
		// storage blocked: the preview still works, only the banner is missing
	}
};

export const readPreviewInfo = () => {
	try {
		const value = localStorage.getItem(INFO_KEY);
		return value ? JSON.parse(value) : null;
	} catch (e) {
		return null;
	}
};

/**
 * The game screen each preview opens directly (no subject dashboard, scoreboard or Did you know /
 * How to play), keyed by the backend's tile. Games that have their own "Play" landing (Present or
 * Past, Pursuit, Quizardy, Connect 4, Mathahtzee) open on the play screen behind it.
 */
const GAME_ROUTES = {
	"/civics": {
		"escape-room": "/civics/escape-room",
		"judicial/dashboard": "/civics/judicial/dashboard",
		constitution: "/civics/constitution",
		"jeo-pardy": "/civics/jeo-pardy",
		"final-module": "/civics/final-module",
		"rapid-fire": "/civics/rapid-fire",
	},
	"/history": { "present-or-past": "/history/present-or-past-game", "rapid-fire": "/history/rapid-fire" },
	"/english": { crossword: "/english/crossword", "rapid-fire": "/english/rapid-fire" },
	"/science": { "periodic-table": "/science/periodic-table", "weakest-link-game": "/science/weakest-link-game", "rapid-fire": "/science/rapid-fire" },
	"/economics": { pursuit: "/economics/pursuit-game", "rapid-fire": "/economics/rapid-fire" },
	"/foreign-language": { quiz: "/foreign-language/quiz-game", "rapid-fire": "/foreign-language/rapid-fire" },
	"/maths": { connect4: "/maths/connect4-game", mathahtzee: "/maths/mathahtzee-game" },
};

/**
 * Where to send the preview and the route state the game screens read (the same values the
 * dashboard's "Lets Play" passes: assessment id, subject, sub-subject, plus Pursuit's and Connect 4's
 * own start values). Civics Legislative opens Bill or No Bill, or Bill Becomes Law when only that is on.
 */
export const previewGameTarget = (session, gamesStatus) => {
	const dashboard = session?.dashboardPath;
	let path = GAME_ROUTES[dashboard]?.[session?.tile];
	if (session?.tile === "legislative-branch") {
		path = gamesStatus?.isBillNoBillActive === false && gamesStatus?.isBillBecomesLawActive ? "/civics/bill-become-law" : "/civics/bill-or-no-bill";
	}
	const state = {
		schoolClassTestId: session?.schoolClassTestId || "",
		subjectId: session?.subjectId || "",
		subsubjectid: session?.subSubjectId || "",
		data: { subjectId: session?.subjectId || "" },
		state: {},
		currentScore: 0,
	};
	return { path: path || dashboard, state };
};
